import {
  faTriangleExclamation,
  faWrench,
  faGlobe,
  faLightbulbOn,
} from '@fortawesome/pro-solid-svg-icons';
import { SignalConfigurationType } from 'components/pages/accounts/detail/all-signals/all-signals-content';

export const sidebarMenuItems = [
  {
    key: SignalConfigurationType.EVERYTHING,
    icon: faGlobe,
    label: 'Everything',
  },
  {
    key: SignalConfigurationType.RISK,
    icon: faTriangleExclamation,
    label: 'Risks',
  },
  {
    key: SignalConfigurationType.OPPORTUNITY,
    icon: faLightbulbOn,
    label: 'Opportunities',
  },
  {
    key: SignalConfigurationType.OPERATIONAL,
    icon: faWrench,
    label: 'Operational',
  },
];

export const myAccountSignalTypes = [
  {
    key: SignalConfigurationType.RISK,
    icon: faTriangleExclamation,
    label: 'Risks',
  },
  {
    key: SignalConfigurationType.OPPORTUNITY,
    icon: faLightbulbOn,
    label: 'Opportunities',
  },
  {
    key: SignalConfigurationType.OPERATIONAL,
    icon: faWrench,
    label: 'Operational',
  },
];
